var ltr6_module_share = (function (ltr6_module_share) {

    ltr6_module_share.init = function(){
      
      setShareLinks();

      function socialWindow(url) {
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 570) / 2;
        var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
        // Setting 'params' to an empty string will launch
        // content in a new tab or window rather than a pop-up.
        // params = "";
        window.open(url,"ShareOnSocialMedia",params);
      }

      function setShareLinks() {
        var pageUrl = encodeURIComponent(document.URL);
        var tweet = encodeURIComponent($("meta[property='og:description']").attr("content"));

        $(".ltr6-social-share-menu .ltr6-social-facebook").on("click", function(event) {
          event.preventDefault();
          // console.log('social');
          url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
          socialWindow(url);
        });

        $(".ltr6-social-share-menu .ltr6-social-twitter").on("click", function(event) {
          event.preventDefault();
          // console.log('social');
          url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + tweet;
          socialWindow(url);
        });

        $(".ltr6-social-share-menu .ltr6-social-linkedin").on("click", function(event) {
          event.preventDefault();
          // console.log('social');
          url = "https://www.linkedin.com/sharing/share-offsite/?url=" + pageUrl;
          socialWindow(url);
        });
      }


      $(".ltr6-share-toggle > a").on("click", function(event) {
        event.preventDefault();
      });

    };

    return ltr6_module_share;
}(ltr6_module_share || {}));